import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import React, { useEffect, useState } from 'react'
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ApiDownloadExcel, ApiGetCategoryReport, ApiRegionVenues } from '../../apiService/Core/Apicall'
import { RootState } from '../../global/config/store'
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice'
import { toast } from 'react-toastify'
import storage from '../../utils/storage'

function CategoryReport() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const Regions = useSelector(RegionList)
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const [categoryreport, setcategoryreport] = useState<any>([])
    const [selectedbutton, setselectedbutton] = useState<number>(0)
    const dispatch = useDispatch()
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)

    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0) {
            setselectedRegion(Regions[0].regionId);
        }
    }, [Regions, clientEntity]);

    const handleChange = (_event: React.MouseEvent<HTMLElement>, newAlignment: number) => {
        if (selectedbutton === newAlignment) return;
        setselectedbutton(newAlignment);
    };

    useEffect(() => {
        const categoryreport = async () => {
            try {
                const data = `?clientEntityId=${storage.getItem('clientEntityId')}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}&regionId=${selectedRegion}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
                const res = await ApiGetCategoryReport(data)
                setcategoryreport(res.data.categories)

            } catch (error) {

            }
        }
        (selectedRegion && startMonth && endMonth) && categoryreport()
    }, [selectedRegion, startMonth, endMonth])

    useEffect(() => {
        setEndMonth(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])


    const handledownloadExcel = async () => {
        try {
            const query = `?reportType=categoryReport&clientEntityId=${storage.getItem(
                "clientEntityId"
            )}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}${selectedRegion ? `&regionId=${selectedRegion}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadExcel(query);

            // Create Excel blob
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Add a default filename
            link.setAttribute(
                "download",
                `Custom_Month.xlsx`
            );

            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };

    return (
        <Box className='mt-3'>
            <Box display={{ xs: "flex", md: 'none' }} width='100% !important' className='align-items-center justify-content-end' >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box display="flex" minWidth={{ xs: '320px', md: '350px' }} gap={3}>
                        <DatePicker value={startMonth} className='input-border-none col-6'
                            label="Start Month: "
                            views={['month', 'year']}
                            format="MMM-YY"
                            maxDate={endMonth}
                            onChange={(e) => { setStartMonth(e); }}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon,
                            }}
                        />
                        <DatePicker value={endMonth} className='input-border-none col-6'
                            label="End Month:"
                            views={['month', 'year']}
                            format="MMM-YY"
                            minDate={startMonth}
                            onChange={(e) => { setEndMonth(e); }}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon,
                            }}
                        />
                    </Box>
                </LocalizationProvider>
                {/* </Box> */}
            </Box>
            <Box className='d-flex  align-items-center justify-content-between mb-2'>
                <Typography className='fw-bold' whiteSpace='nowrap' fontSize={{ xs: '18px', md: '20px' }}>Category Report</Typography>
                <Box display={{ md: "flex", xs: 'none' }} className='gap-5  align-items-center justify-content-end col-8'>
                    <Button className='btn-main px-3' onClick={() => { handledownloadExcel() }}>Download Excel</Button>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'auto', minWidth: "200px" }} className='justify-content-end'>
                            <InputLabel id="demo-simple-select-label">Region</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                label='Region'
                                id="demo-simple-select"
                                defaultValue={Regions[0]?.regionId}
                                value={selectedRegion}
                                onChange={(e: any) => { setselectedRegion(e.target.value) }}
                            >
                                {Regions?.map((item: any, index: number) => (
                                    <MenuItem key={index} value={item.regionId}>
                                        {item.regionName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    {/* <Box justifyContent={{ xs: 'start', md: 'end' }} border='1px solid red' className='col-5  d-flex align-itmes-center'> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" justifyContent='end' width='20%' minWidth={{ xs: '300px', md: '400px' }} gap={3}>
                            <DatePicker value={startMonth} className='input-border-none col-6'
                                label="Start Month: "
                                views={['month', 'year']}
                                format="MMM-YY"
                                maxDate={endMonth}
                                onChange={(e) => { setStartMonth(e); }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                            <DatePicker value={endMonth} className='input-border-none col-6'
                                label="End Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                minDate={startMonth}
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }} slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>
                    {/* </Box> */}
                </Box>
                <Box display={{ xs: "flex", md: 'none' }}>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '200px' }} className='justify-content-end text-end'>
                            {/* <InputLabel id="demo-simple-select-label" shrink={false}>Region: &nbsp;</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                defaultValue={Regions[0]?.regionId}
                                value={selectedRegion}
                                onChange={(e: any) => { setselectedRegion(e.target.value) }}
                            >
                                {Regions?.map((item: any, index: number) => (
                                    <MenuItem key={index} value={item.regionId}>
                                        {item.regionName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Box>

            </Box>

            <Box className='d-flex align-items-stretch mt-3 gap-2'>
                <Box className='col-3  border border-20 p-3'>
                    <ToggleButtonGroup className='d-flex  flex-column selected gap-2' value={selectedbutton} onChange={handleChange}
                        exclusive >
                        {categoryreport.length > 0 && categoryreport.map((item: any, index: number) => (
                            <ToggleButton className='border border-10 w-100 justify-content-start d-flex text-main' key={index} sx={{ textTransform: 'none' }} value={index}>{item.categoryName}</ToggleButton>

                        ))}
                        {/* <ToggleButton className='border border-10 w-100 justify-content-start d-flex text-main' sx={{ textTransform: 'none' }} value='Scanning'> Scanning</ToggleButton> */}
                    </ToggleButtonGroup>
                </Box>
                <Box className='col-9'>
                    <Grid container spacing={2} className='bg-light-main p-3 border-20'>
                        {(selectedbutton !== null && categoryreport.length > 0) && categoryreport[selectedbutton]?.scores.map((item: any, index: number) => {
                            return (
                                <Grid size={6} key={index} className='d-flex align-items-center justify-content-between mb-3 gap-2'>
                                    <Grid container className='w-100' spacing={2}>
                                        <Grid size={2}>
                                            <Typography fontSize='14px' className='text-main'>{item?.venueName}</Typography>
                                        </Grid>
                                        <Grid size={10}>
                                            <Box className="d-flex align-items-center" gap={1}>
                                                <div className="custom-progress-bar">
                                                    <div className="progress-fill" style={{ width: `${item?.score ?? 0}%` }}></div>
                                                </div>
                                                <Typography fontWeight={900}>{item?.score ?? 'N/A'}%</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            );
                        })}

                    </Grid>
                </Box>
            </Box>

        </Box>
    )
}

export default CategoryReport
